module.exports = __webpack_public_path__ + "img/27.93f8c669.jpg";